module.exports = __webpack_public_path__ + "static/media/Developer.122dc71f.jpg";